/**
 * @generated SignedSource<<515b3a2e424c1d2585af2f8af6beb8bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutRegistrationMarketingOptIn_viewer$data = {
  readonly gdprDisplayInfo: {
    readonly isGdprApplicable: boolean | null;
    readonly marketingOptInMessage: string | null;
  } | null;
  readonly " $fragmentType": "CheckoutRegistrationMarketingOptIn_viewer";
};
export type CheckoutRegistrationMarketingOptIn_viewer$key = {
  readonly " $data"?: CheckoutRegistrationMarketingOptIn_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRegistrationMarketingOptIn_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutRegistrationMarketingOptIn_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "gdprDisplayInfo",
      "kind": "LinkedField",
      "name": "gdprDisplayInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            }
          ],
          "kind": "ScalarField",
          "name": "isGdprApplicable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "marketingOptInMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "54d01381ac953b5825f07eac40adf1c3";

export default node;
